import { render, staticRenderFns } from "./erLogo.vue?vue&type=template&id=309e449c&"
import script from "./erLogo.vue?vue&type=script&lang=js&"
export * from "./erLogo.vue?vue&type=script&lang=js&"
import style0 from "./erLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports